import { render, staticRenderFns } from "./PreviewBusTable.vue?vue&type=template&id=69268da5&scoped=true&"
import script from "./PreviewBusTable.vue?vue&type=script&lang=js&"
export * from "./PreviewBusTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewBusTable.vue?vue&type=style&index=0&id=69268da5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69268da5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VTextField})
